var $cf357c66385c008a$exports = {};
$cf357c66385c008a$exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`
};


export {$cf357c66385c008a$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
